export const AUTH_TOKEN = 'auth_token'
export const REFRESH_TOKEN = 'refresh_token'

export const NO_HEADER_SIDENAV_ROUTES = ["/editor", "/chatbot", "/building","/content-builder","/mediaList"];

export const TOKEN ={
    BEARER:'Bearer '
}
 